import { LANGUAGE } from "@/common/utils/constants.js";

export const END_SLIDE_PPT = {

	[LANGUAGE.en.short]: {
		discoverMore: `<p style="color:#00FFFF;">Discover more on <a href="https://drc-akkodis.com/" style="color:white">www.akkodis.com</a>`,
		futureTogether: "Engineering a Smarter Future Together"
	},
	[LANGUAGE.de.short]: {
		discoverMore: `<p style="color:#00FFFF;">Entdecken Sie mehr auf  <a href="https://drc-akkodis.com/" style="color:white">www.akkodis.com</a></p>`,
		futureTogether: "Gemeinsam eine intelligentere Zukunft gestalten"
	},
	[LANGUAGE.fr.short]: {
		discoverMore: `<p style="color:#00FFFF;">En savoir plus sur  <a href="https://drc-akkodis.com/" style="color:white">www.akkodis.com</a></p>`,
		futureTogether: "Concevoir ensemble un avenir plus intelligent"
	},
	[LANGUAGE.it.short]: {
		discoverMore: `<p style="color:#00FFFF; ">Scopri di più su  <a href="https://drc-akkodis.com/" style="color:white">www.akkodis.com</a></p>`,
		futureTogether: "Progettare insieme un futuro più intelligente"
	},
	[LANGUAGE.ja.short]: {
		discoverMore: `<p style="color:#00FFFF;">さらに詳しく見る  <a href="https://drc-akkodis.com/" style="color:white">www.akkodis.com</a></p>`,
		futureTogether: "よりスマートな未来を一緒に設計する"
	},
	[LANGUAGE.es.short]: {
		discoverMore: `<p style="color:#00FFFF;">Descubre más en  <a href="https://drc-akkodis.com/" style="color:white">www.akkodis.com</a></p>`,
		futureTogether: "Diseñando un futuro más inteligente juntos"
	},
}
